/** ขีดเดียวไร้ถ้อย (lane C3 skeleton): scholar azure + ink, ink drips. Built from swordKit via families/swordArtGen.ts; polish later. */
import { makeArt } from '../families/swordArtGen';

export const SAGE_FX: ReturnType<typeof makeArt> = makeArt('one-cut', { a: 'azure', b: 'ink', motif: 'ink' }, [
  ['sg-line', 'lock'],
  ['sg-verse', 'break'],
  ['sg-rhyme', 'slash'],
  ['sg-stroke', 'thrust', 100],
  ['sg-scroll', 'sweep', 5],
  ['sg-insight', 'buff'],
  ['sg-screen', 'buff'],
  ['sg-masterpiece', 'power', 4],
]);
